/**
 * EagleView OAuth configuration utility.
 *
 * OAuth credentials and endpoints matching the mobile app's configuration.
 * These are the same values used by the mobile client for the
 * Authorization Code + PKCE flow against EagleView's API Center.
 */

export interface EagleViewOAuthConfig {
  clientId: string;
  clientSecret: string;
  authEndpoint: string;
  tokenEndpoint: string;
  redirectUri: string;
}

/**
 * Returns EagleView OAuth configuration.
 * Credentials and endpoints match the mobile app's implementation.
 * Environment variables can override if set, otherwise uses defaults.
 */
export function getEagleViewConfig(): EagleViewOAuthConfig {
  return {
    clientId:
      process.env.REACT_APP_EAGLEVIEW_CLIENT_ID || '0oa1apie0lml7Om2x2p8',
    clientSecret:
      process.env.REACT_APP_EAGLEVIEW_CLIENT_SECRET ||
      'bSl0VIUvBYvCoBzvfDVqPVKoSNcGsYGNJOhJ2lX4mcNQ1x9P5zmuXPh4k2vFsfk2',
    authEndpoint:
      process.env.REACT_APP_EAGLEVIEW_AUTH_ENDPOINT ||
      'https://apicenter.eagleview.com/oauth2/v1/authorize',
    tokenEndpoint:
      process.env.REACT_APP_EAGLEVIEW_TOKEN_ENDPOINT ||
      'https://apicenter.eagleview.com/oauth2/v1/token',
    redirectUri: `${window.location.origin}/settings/integrations/eagleview/callback`,
  };
}
